module.exports = __webpack_public_path__ + "static/media/404.3781a522.png";